export function and() {
  for (var _len = arguments.length, fs = Array(_len), _key = 0; _key < _len; _key++) {
    fs[_key] = arguments[_key];
  }

  if (fs.length === 0) throw new Error('Combinator `and` expects one or more matchers but found none.');
  return function (x) {
    var _pass = true;
    var _type = 'unknown';

    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];

      var _f = f(x),
          pass = _f.pass,
          type = _f.type;

      if (!pass) {
        _type = type;
        _pass = pass;
        break;
      }
    }

    return {
      type: _type,
      pass: _pass
    };
  };
}
export function or() {
  for (var _len2 = arguments.length, fs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fs[_key2] = arguments[_key2];
  }

  if (fs.length === 0) throw new Error('Combinator `or` expects one or more matchers but found none.');
  return function (x) {
    var _pass = false;
    var types = [];

    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];

      var _f2 = f(x),
          pass = _f2.pass,
          type = _f2.type;

      types.push(type);

      if (pass) {
        _pass = pass;
        break;
      }
    }

    return {
      type: '' + types.join(' | '),
      pass: _pass
    };
  };
}